import { useState } from 'react'

export const usePopup = () => {
  const [anchorElement, setAnchorElement] = useState(null)
  const showPopup = event => setAnchorElement(!!event.currentTarget ? event.currentTarget : event)
  const closePopup = () => setAnchorElement(null)
  const isPopupOpen = Boolean(anchorElement)
  return [isPopupOpen, showPopup, closePopup, anchorElement]
}
